{********************************************************************}
{                                                                    }
{ written by TMS Software                                            }
{            copyright (c) 2021                                      }
{            Email : info@tmssoftware.com                            }
{            Web : http://www.tmssoftware.com                        }
{                                                                    }
{ The source code is given as is. The author is not responsible      }
{ for any possible damage done due to the use of this code.          }
{ The complete source code remains property of the author and may    }
{ not be distributed, published, given or sold in any form as such.  }
{ No parts of the source code can be included in any other component }
{ or application without written authorization of the author.        }
{********************************************************************}

unit WEBLib.TMSFNCWXVideoPlayer;

{$I WEBLib.TMSFNCDefines.inc}

interface

uses
  Classes, SysUtils, StrUtils, WEBLib.TMSFNCCustomWEBControl, WEBLib.TMSFNCTypes,
  WEBLib.TMSFNCCustomControl, WEBLib.TMSFNCWXMediaPlayer;

type
  TTMSFNCWXCustomVideoPlayer = class(TTMSFNCWXCustomMediaPlayer)
  private
    FAutoPictureInPicture: Boolean;
    FDisablePictureInPicture: Boolean;
    FOnPictureInPictureEnter: TNotifyEvent;
    FOnPictureInPictureLeave: TNotifyEvent;
    FOnVideoInitialized: TNotifyEvent;
    FPoster: string;
    FPictureInPicture: Boolean;
    procedure SetAutoPiP(const Value: Boolean);
    procedure SetDisablePiP(const Value: Boolean);
    procedure SetPictureInPicture(const Value: Boolean);
    procedure SetPoster(const value: string);
    function IsPosterStored: Boolean;
  protected
    function GetBody: string; override;
    function GetCustomFunctions: string; override;
    function GetDocURL: string; override;
    procedure CallCustomEvent(AEventData: TTMSFNCCustomWEBControlEventData); override;
    procedure HandleMediaInitialized; override;
    procedure HandleOnPiPEnter(const Val: string);
    procedure HandleOnPiPLeave(const Val: string);
    function GetWaitInitElseStatement: string; override;
    property AutoPictureInPicture: Boolean read FAutoPictureInPicture write SetAutoPiP default False;
    property DisablePictureInPicture: Boolean read FDisablePictureInPicture write SetDisablePiP default True;
    property Poster: string read FPoster write SetPoster stored IsPosterStored nodefault;
    property PictureInPicture: Boolean read FPictureInPicture write SetPictureInPicture default False;
    property OnPictureInPictureEnter: TNotifyEvent read FOnPictureInPictureEnter write FOnPictureInPictureEnter;
    property OnPictureInPictureLeave: TNotifyEvent read FOnPictureInPictureLeave write FOnPictureInPictureLeave;
    property OnVideoInitialized: TNotifyEvent read FOnVideoInitialized write FOnVideoInitialized;
  public
    constructor Create(AOwner: TComponent); override;
    procedure ForwardVideo(const Value: Integer);
    procedure RewindVideo(const Value: Integer);
  end;

  {$IFNDEF LCLLIB}
  [ComponentPlatformsAttribute(TMSPlatformsWeb)]
  {$ENDIF}
  TTMSFNCWXVideoPlayer = class(TTMSFNCWXCustomVideoPlayer)
  published
    property AutoClearCache;
    property AutoPlay;
    property AutoPictureInPicture;
    property Controls;
    property CurrentTime;
    property Duration;
    property DisablePictureInPicture;
    property EnableContextMenu default False;
    property EnableShowDebugConsole default False;
    property IsPlaying;
    property Loop;
    property Muted;
    property OnPlay;
    property OnPause;
    property OnEnded;
    property OnRateChange;
    property OnVolumeChange;
    property OnTimeUpdate;
    property OnError;
    property OnPictureInPictureEnter;
    property OnPictureInPictureLeave;
    property OnMetaDataLoaded;
    property OnVideoInitialized;
    property PictureInPicture;
    property PlayBackRate;
    property Preload;
    property Poster;
    property URL;
    property Volume;
  end;

implementation

uses
  WEBLib.TMSFNCWXMediaPlayer.Consts, WEBLib.TMSFNCWXVideoPlayer.Consts;

procedure TTMSFNCWXCustomVideoPlayer.CallCustomEvent
  (AEventData: TTMSFNCCustomWEBControlEventData);
begin
  inherited;

  if AEventData.EventName <> '' then
  begin
    case IndexStr(AEventData.EventName,[ONVIDEOPIPENTER, ONVIDEOPIPLEAVE]) of
      0: HandleOnPiPEnter(AEventData.CustomData);
      1: HandleOnPiPLeave(AEventData.CustomData);
    end;
  end;
end;

procedure TTMSFNCWXCustomVideoPlayer.HandleOnPiPEnter(const Val: string);
var
  isPip: Boolean;
begin
  isPip := StrToBool(StringReplace(Val, '"', '', [rfReplaceAll]));

  if isPip <> FPictureInPicture then
    FPictureInPicture := isPip;

  if Assigned(OnPictureInPictureEnter) then
    OnPictureInPictureEnter(Self);
end;

procedure TTMSFNCWXCustomVideoPlayer.HandleOnPiPLeave(const Val: string);
var
  isPip: Boolean;
begin
  isPip := StrToBool(StringReplace(Val, '"', '', [rfReplaceAll]));

  if isPip <> FPictureInPicture then
    FPictureInPicture := isPip;

  if Assigned(OnPictureInPictureLeave) then
    OnPictureInPictureLeave(Self);
end;

function TTMSFNCWXCustomVideoPlayer.IsPosterStored: Boolean;
begin
  Result := FPoster <> '';
end;

procedure TTMSFNCWXCustomVideoPlayer.HandleMediaInitialized;
begin
  inherited;

  if not (csDesigning in componentstate) then
  begin
    ExecuteJavascript(StringReplace(Format(TOGGLEAUTOPIP, [BoolToStr(FAutoPictureInPicture)]),
      CONTROL_ID, GetControlID, [rfReplaceAll]));

    ExecuteJavascript(StringReplace(Format(TOGGLEENABLEPIP, [BoolToStr(FDisablePictureInPicture)]),
      CONTROL_ID, GetControlID, [rfReplaceAll]));
  end;

  ExecuteJavascript(StringReplace(Format(VIDEOPOSTER, [FPoster]), CONTROL_ID, GetControlID, [rfReplaceAll]));

  if Assigned(OnVideoInitialized) then
    OnVideoInitialized(Self);
end;
procedure TTMSFNCWXCustomVideoPlayer.SetAutoPiP(const Value: Boolean);
begin
  FAutoPictureInPicture := Value;

  if ((UpdateCount = 0) and not (csDesigning in ComponentState)) then
    ExecuteJavascript(StringReplace(Format(TOGGLEAUTOPIP,[BoolToStr(FAutoPictureInPicture)]), CONTROL_ID, GetControlID, [rfReplaceAll]));
end;

procedure TTMSFNCWXCustomVideoPlayer.SetDisablePiP(const Value: Boolean);
begin
  FDisablePictureInPicture := Value;

  if ((UpdateCount = 0) and not (csDesigning in ComponentState)) then
    ExecuteJavascript(StringReplace(Format(TOGGLEENABLEPIP, [BoolToStr(FDisablePictureInPicture)]), CONTROL_ID, GetControlID, [rfReplaceAll]));
end;

procedure TTMSFNCWXCustomVideoPlayer.SetPictureInPicture(const Value: Boolean);
begin
  FPictureInPicture := Value;

  if ((UpdateCount = 0) and not (csDesigning in ComponentState)) then
    ExecuteJavascript(StringReplace(Format(TOGGLEPIP, [BoolToStr(FPictureInPicture)]), CONTROL_ID, GetControlID, [rfReplaceAll]));
end;

procedure TTMSFNCWXCustomVideoPlayer.SetPoster(const Value: string);
begin
  FPoster := value;

  if UpdateCount = 0 then
    ExecuteJavascript(StringReplace(Format(VIDEOPOSTER, [FPoster]), CONTROL_ID, GetControlID, [rfReplaceAll]));
end;

function TTMSFNCWXCustomVideoPlayer.GetBody: string;
begin
  Result :=
    '  <video style="width:100%;height:100%;overflow:none;" id="' + GetControlID + '" src="' + URL + '">' + LB +
    '    Videoformat not supported! ' + LB +
    '  </video>';
end;

function TTMSFNCWXCustomVideoPlayer.GetCustomFunctions: string;
begin
  Result := inherited;
  Result := Result + GetWXVideoScript(GetControlID);
end;

function TTMSFNCWXCustomVideoPlayer.GetDocURL: string;
begin
Result := 'https://download.tmssoftware.com/doc/tmsfncwxpack/ttmsfncwxvideoplayer/';
end;

function TTMSFNCWXCustomVideoPlayer.GetWaitInitElseStatement: string;
begin
  Result := inherited;
  Result := Result + GetWXInitializeVideoScript(GetControlID, GetDefaultEventDataObject);
end;

constructor TTMSFNCWXCustomVideoPlayer.Create(AOwner: TComponent);
begin
  inherited;
  FURL := 'https://upload.wikimedia.org/wikipedia/commons/3/37/Big_Buck_Bunny_with_VTT_acid_test.webm';
  FPictureInPicture := False;
  FAutoPictureInPicture := False;
  FDisablePictureInPicture := True;
  RemoveMargins := true;
end;

procedure TTMSFNCWXCustomVideoPlayer.ForwardVideo(const Value: Integer);
begin
  ForwardMedia(Value);
end;

procedure TTMSFNCWXCustomVideoPlayer.RewindVideo(const Value: Integer);
begin
  Rewind(Value);
end;

end.

